import type { WWCCQualificationType } from '@/modules/auth/types/WWCCQualificationType';

class WWCCQualificationService {
  getWWCCQualificationTypes() {
    return useAsyncData<WWCCQualificationType[]>(
      'wwcc-qualification-types',
      async () => {
        const { data, error, execute } = useSubmit();
        await execute('worker/wwcc-qualification-types', {
          method: 'GET',
        });
        
        if (error.value) {
          throw error.value;
        }
        // Handle different response structures
        let responseData = data.value;
        if (data.value && typeof data.value === 'object' && 'data' in data.value) {
          responseData = data.value.data;
        }
        return responseData || [];
      },
      { server: false }
    );
  }
}

export default new WWCCQualificationService(); 